import axios, { AxiosInstance } from 'axios';

const runtimeBaseUrl = typeof window !== 'undefined' ? window.location.origin : '';
const configuredBaseUrl = process.env.VUE_APP_API_BASE_URL || runtimeBaseUrl;

// Создаем экземпляр Axios с базовыми настройками
const instance: AxiosInstance = axios.create({
  baseURL: configuredBaseUrl.replace(/\/$/, ''),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Если необходимо, вы можете добавить интерсепторы или другие настройки здесь
// instance.interceptors.request.use(config => {
//   // Добавляем токены или изменяем запросы
//   return config;
// });

// instance.interceptors.response.use(response => {
//   // Обрабатываем успешные ответы
//   return response;
// }, error => {
//   // Обрабатываем ошибки
//   return Promise.reject(error);
// });

export default instance;
